<template>
  <!-- 数据结构管理 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="dataBase"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="dataBase" leftIndex="dbSortManage"></LeftSideBar>
    </div>

    <div id="deptContentBox" class="base-content">
      <!-- 上方按钮 -->
      <div>
        <el-button
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="firstCreate()"
          >新建</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          @click="preCheck('toEdit')"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-close"
          @click="preCheck('toDelete')"
          >删除</el-button
        >
      </div>
      <!-- 展示列表 -->
      <el-table
        :data="sourceTableData"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
        @selection-change="handleTableSelectionChange"
      >
        <el-table-column
          type="selection"
          min-width="55"
          align="center"
        ></el-table-column>
        <el-table-column type="index" min-width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          min-width="80"
          label="数据结构名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="remark"
          show-overflow-tooltip
          label="备注"
          align="center"
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              class="right-add-button"
              style="display: block; border: none; margin: 0 auto"
              @click="sortPreview(scope.row)"
              :disabled="scope.row.id == '100091'"
              >【预览】</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalSize"
        >
        </el-pagination>
      </div> -->
    </div>
    <el-dialog title="新建数据结构" :visible.sync="createDialog" width="600px">
      <el-form
        ref="addSourceForm"
        :rules="addSourceRules"
        :model="addSourceForm"
      >
        <el-form-item label="数据结构名称:" label-width="120px" prop="name">
          <el-input
            v-model="addSourceForm.name"
            placeholder="请输入数据结构名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类：" label-width="120px" prop="classify">
          <el-select v-model="addSourceForm.classify" clearable>
            <el-option
              v-for="item in sortList"
              :key="item.id"
              :value="item.id"
              :label="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" label-width="120px">
          <el-input
            v-model="addSourceForm.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" round @click="sortViewDialog = true">
        查看数据结构
      </el-button>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="createSource('addSourceForm')"
          >确 定
        </el-button>
        <el-button @click="createDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑数据结构弹窗 -->
    <el-dialog title="编辑数据结构" :visible.sync="editDialog" width="600px">
      <el-form
        ref="editSourceForm"
        :rules="editSourceRules"
        :model="editSourceForm"
      >
        <el-form-item label="数据结构名称" label-width="110px" prop="name">
          <el-input
            v-model="editSourceForm.name"
            placeholder="请输入数据结构名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" label-width="110px">
          <el-input
            v-model="editSourceForm.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateSource('editSourceForm')"
          >确 定
        </el-button>
        <el-button @click="editDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 删除数据结构弹窗 -->
    <el-dialog
      title="删除数据结构"
      :visible.sync="deleteDialog"
      width="30%"
      center
    >
      <div>确定删除该数据结构？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onDelete">确 定</el-button>
        <el-button @click="deleteDialog = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 数据结构查看弹窗 -->
    <el-dialog
      title="数据结构查看"
      :visible.sync="sortViewDialog"
      width="80%"
      center
    >
      <el-table
        :data="sorttableData"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="width: 100%"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column
          prop="name"
          width="300px"
          label="结构名称"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="text"
          :show-overflow-tooltip="false"
          label="结构"
          align="left"
        >
          <template slot-scope="scope">
            <div v-html="scope.row.text"></div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 数据结构预览弹窗 -->
    <el-dialog
      title="当前数据结构预览"
      :visible.sync="currentSortViewDialog"
      width="80%"
      center
    >
      <p
        v-html="currentSortView"
        style="padding: 15px 80px; line-height: 2.2em; font-size: 16px"
      ></p>
    </el-dialog>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
import $ from "jquery";
import cookies from "vue-cookies";
export default {
  data() {
    return {
      addSourceForm: {
        name: "",
        remark: "",
        classify: "",
      },
      editSourceForm: {
        id: "",
        name: "",
        remark: "",
      },
      sourceForm: {
        id: "",
        name: "",
      },
      sorttableData: [
        {
          name: "不列颠",
          text: "&lt;!--文件格式说明--&gt;<br>image_jpg(图片文件夹)<br>&nbsp;&nbsp;--jieri01.jpg<br>&nbsp;&nbsp;--jieri02.jpg<br>xml(xml文件夹)<br>&nbsp;&nbsp;--示例1.xml<br>&nbsp;&nbsp;--示例2.xml<br>&lt;Root&gt;<br>&lt;entry&gt;<br>&lt;CDOI&gt;10051015000000036398750276344&lt;/CDOI&gt;<br>&lt;Itemid&gt;796a9705-8ad6-11ec-aceb-d8cb8a4c2783&lt;/Itemid&gt;<br>&lt;ItemNum&gt;00229&lt;/ItemNum&gt;<br>&lt;itemen&gt;Herne,&nbsp;James&nbsp;A.&lt;/itemen&gt;<br>&lt;itemcn&gt;赫恩&lt;/itemcn&gt;<br>&lt;p&gt;&lt;PersonAge&gt;1839-02-01，美国纽约特洛伊～1901-06-02，纽约市&lt;/PersonAge&gt;&lt;/p&gt;<br>&lt;body&gt;<br>&lt;!--&nbsp;正文基本格式&nbsp;--&gt;<br>&lt;!--&nbsp;标题格式&lt;FIRSTTITLE&gt;&lt;SECONDTITLE&gt;&lt;THIRDTITLE&gt;&lt;FOURTHTITLE&gt;&lt;FIFTHTITLE&gt;&nbsp;--&gt;<br><br>&lt;p&gt; &lt;SECONDTITLE&gt;标题&lt;/SECONDTITLE&gt; 原名James&nbsp;Ahern（詹姆斯·埃亨）。美国剧作家。他的作品是19世纪通俗情节剧和20世纪思想剧之间的桥梁。曾在巡回剧团当了几年演员，1879年发表与年轻的D.贝拉斯科合写的第一个剧本《果断的人们》，获得很大成功。剧本《离异》(1885)、《民兵》(1886)和《玛格丽特·弗莱明》(1890)却不受欢迎。人们认为&lt;HOTLINK&gt;《玛格丽特·弗莱明》&lt;HOTLINK&gt;（一部关于婚姻不忠的剧本）是他的主要成就。最受群众欢迎的剧本是《海边的地产》，1892年首次上演。他以刻画人物性格见长。&lt;/p&gt;<br>&lt;!--&nbsp;图片格式&nbsp;--&gt;<br>&lt;p&nbsp;align=&quot;center&quot;&gt;&lt;STORY&gt;&lt;TABLE_TITLE&gt;赫恩&lt;/TABLE_TITLE&gt;&lt;IMG&nbsp;src=&quot;image_jpg/images08/jieri01.jpg&quot;&gt;&lt;/IMG&gt;&lt;TABLE_DESC/&gt;&lt;/STORY&gt;&lt;/p&gt;<br>&lt;!--&nbsp;表格&nbsp;--&gt;<br>&lt;![CDATA[<br>&lt;div&nbsp;align=&quot;center&quot;&gt;<br>&lt;p&nbsp;align=&quot;center&quot;&nbsp;style=&quot;font-size:8.50pt;line-height:150%&quot;&gt;&lt;TABLE_TITLE&gt;神圣罗马帝国皇帝&lt;/TABLE_TITLE&gt;&lt;/p&gt;<br>&lt;p&nbsp;style=&quot;font-size:8.00pt;line-height:150%&quot;&gt;&lt;/p&gt;<br>&lt;TABLE&nbsp;BORDER=&quot;1&quot;&nbsp;Rules=&quot;ALL&quot;&nbsp;style=&quot;font-size:8.00pt;line-height:150%&quot;&gt;&lt;TR&gt;&lt;TD&nbsp;colspan=&quot;2&quot;&gt;&lt;p&nbsp;style=&quot;font-size:8.00pt;line-height:150%&quot;&gt;加洛林王朝&lt;/p&gt;<br>&lt;TR&gt;&lt;TD&nbsp;colspan=&quot;1&quot;&gt;&lt;p&nbsp;style=&quot;font-size:8.00pt;line-height:150%&quot;&gt;查理曼（查理一世）&lt;/p&gt;&lt;/TD&gt;<br>line-height:150%&quot;&gt;800～814&lt;/p&gt;&lt;/TD&gt;<br>&lt;TR&gt;&lt;TD&nbsp;colspan=&quot;1&quot;&gt;&lt;p&nbsp;style=&quot;font-size:8.00pt;line-height:150%&quot;&gt;路易一世&lt;/p&gt;&lt;/TD&gt;<br>...<br>&lt;/TABLE&gt;&lt;/div&gt;]]&gt;<br>&lt;/body&gt;&lt;/entry&gt;<br>&lt;entry&gt;...&lt;/entry&gt;<br>&lt;/Root&gt;",
        },
        {
          name: "一版",
          text: "&lt;!--文件格式说明--&gt;<br>image_jpg(图片文件夹)<br>&nbsp;&nbsp;--jieri01.jpg<br>&nbsp;&nbsp;--jieri02.jpg<br>xml(xml文件夹)<br>&nbsp;&nbsp;--示例1.xml<br>&nbsp;&nbsp;--示例2.xml<br>&lt;Root&gt;<br>&lt;entry&gt;<br>&lt;Itemid&gt;6cb44af1-90ee-11e6-895f-d8cb8a4c2783&lt;/Itemid&gt;<br>&lt;PdfNum&gt;&lt;/PdfNum&gt;<br>&lt;PdfNum_end&gt;&lt;/PdfNum_end&gt;<br>&lt;volume&gt;交通&lt;/volume&gt;<br>&lt;classid&gt;&lt;/classid&gt;<br>&lt;!--所属分类信息--&gt;<br>&lt;categoryName&gt;交通&lt;/categoryName&gt;<br>&lt;classpath&gt;&lt;/classpath&gt;<br>&lt;ItemType&gt;术语&lt;/ItemType&gt;<br>&lt;itemcn&gt;阿尔及利亚－意大利输气管道&lt;/itemcn&gt;<br>&lt;itemen&gt;Algeria-Italy&nbsp;Natural&nbsp;Gas&nbsp;Pipeline&lt;/itemen&gt;<br>&lt;itempy&gt;A&#39;erjiliyɑ-Yidɑli&nbsp;Shuqi&nbsp;Guɑndɑo&lt;/itempy&gt;<br>&lt;PersonAge&gt;&lt;/PersonAge&gt;<br>&lt;Age&gt;&lt;/Age&gt;<br>&lt;AUTHORS&gt;&lt;AUTHOR&gt;梁翕章&lt;/AUTHOR&gt;&lt;/AUTHORS&gt;<br>&lt;body&gt;<br>&lt;!--&nbsp;正文基本格式&nbsp;--&gt;<br>&lt;!--&nbsp;标题格式&lt;FIRSTTITLE&gt;&lt;SECONDTITLE&gt;&lt;THIRDTITLE&gt;&lt;FOURTHTITLE&gt;&lt;FIFTHTITLE&gt;&nbsp;--&gt;<br><br>&lt;p&gt; &lt;SECONDTITLE&gt;标题&lt;/SECONDTITLE&gt; 原名James&nbsp;Ahern（詹姆斯·埃亨）。美国剧作家。他的作品是19世纪通俗情节剧和20世纪思想剧之间的桥梁。曾在巡回剧团当了几年演员，1879年发表与年轻的D.贝拉斯科合写的第一个剧本《果断的人们》，获得很大成功。剧本《离异》(1885)、《民兵》(1886)和《玛格丽特·弗莱明》(1890)却不受欢迎。人们认为&lt;HOTLINK&gt;《玛格丽特·弗莱明》&lt;HOTLINK&gt;（一部关于婚姻不忠的剧本）是他的主要成就。最受群众欢迎的剧本是《海边的地产》，1892年首次上演。他以刻画人物性格见长。&lt;/p&gt;<br>&lt;!--&nbsp;图片格式&nbsp;--&gt;<br>&lt;p&nbsp;align=&quot;center&quot;&gt;&lt;STORY&gt;&lt;PIC_TITLE&gt;赫恩&lt;/PIC_TITLE&gt;&lt;IMG&nbsp;src=&quot;image_jpg/images08/jieri01.jpg&quot;&gt;&lt;/IMG&gt;&lt;PIC_DESC/&gt;&lt;/STORY&gt;&lt;/p&gt;<br>&lt;!--&nbsp;图集格式--&gt;<br>&lt;STORY_GROUP&gt;<br>&lt;IMG_GROUP_TITLE&gt;图集标题&lt;/IMG_GROUP_TITLE&gt;<br>&lt;IMG_GROUP_DESC&gt;图集描述&lt;/IMG_GROUP_DESC&gt;<br>&lt;p&nbsp;align=&quot;center&quot;&gt;&lt;STORY&gt;&lt;PIC_TITLE&gt;图1&lt;/PIC_TITLE&gt;&lt;IMG&nbsp;src=&quot;image_jpg/images08/jieri01.jpg&quot;&gt;&lt;/IMG&gt;&lt;PIC_DESC/&gt;&lt;/STORY&gt;&lt;/p&gt;<br>&lt;p&nbsp;align=&quot;center&quot;&gt;&lt;STORY&gt;&lt;PIC_TITLE&gt;图2&lt;/PIC_TITLE&gt;&lt;IMG&nbsp;src=&quot;image_jpg/images08/jieri02.jpg&quot;&gt;&lt;/IMG&gt;&lt;PIC_DESC/&gt;&lt;/STORY&gt;&lt;/p&gt;<br>...<br>&lt;/STORY_GROUP&gt;<br>&lt;!--&nbsp;表格&nbsp;--&gt;<br>&lt;TABLE&gt;...&lt;/TABLE&gt;<br>&lt;/body&gt;<br>&lt;!--&nbsp;引文--&gt;<br>&lt;REFERENCE_LIST&gt;<br>&lt;REFERENCE_CONTENT&gt;....&lt;/REFERENCE_CONTENT&gt;<br>&lt;REFERENCE_CONTENT&gt;....&lt;/REFERENCE_CONTENT&gt;<br>&lt;/REFERENCE_LIST&gt;<br>&lt;/entry&gt;<br>&lt;entry&gt;...&lt;/entry&gt;<br>&lt;entry&gt;...&lt;/entry&gt;<br>...<br>&lt;/Root&gt;",
        },
        {
          name: "二版",
          text: "&lt;!--文件格式说明--&gt;<br>image(原图文件夹，文件名称与image_jpg的文件除了后缀不同其他保持一致)<br>&nbsp;&nbsp;--jieri01.eps<br>&nbsp;&nbsp;--jieri02.eps<br>image_jpg(网络图片文件夹)<br>&nbsp;&nbsp;--jieri01.jpg<br>&nbsp;&nbsp;--jieri02.jpg<br>xml(xml文件夹)<br>&nbsp;&nbsp;--示例1.xml<br>&nbsp;&nbsp;--示例2.xml<br>&lt;Root&gt;<br>&lt;entry&gt;<br>&lt;Itemid&gt;6cb44af1-90ee-11e6-895f-d8cb8a4c2783&lt;/Itemid&gt;<br>&lt;PdfNum&gt;&lt;/PdfNum&gt;<br>&lt;PdfNum_end&gt;&lt;/PdfNum_end&gt;<br>&lt;volume&gt;交通&lt;/volume&gt;<br>&lt;classid&gt;&lt;/classid&gt;<br>&lt;!--所属分类信息--&gt;<br>&lt;categoryName&gt;交通&lt;/categoryName&gt;<br>&lt;classpath&gt;&lt;/classpath&gt;<br>&lt;ItemType&gt;术语&lt;/ItemType&gt;<br>&lt;itemcn&gt;阿尔及利亚－意大利输气管道&lt;/itemcn&gt;<br>&lt;itemen&gt;Algeria-Italy&nbsp;Natural&nbsp;Gas&nbsp;Pipeline&lt;/itemen&gt;<br>&lt;itempy&gt;A&#39;erjiliyɑ-Yidɑli&nbsp;Shuqi&nbsp;Guɑndɑo&lt;/itempy&gt;<br>&lt;PersonAge&gt;&lt;/PersonAge&gt;<br>&lt;Age&gt;&lt;/Age&gt;<br>&lt;AUTHORS&gt;&lt;AUTHOR&gt;梁翕章&lt;/AUTHOR&gt;&lt;/AUTHORS&gt;<br>&lt;body&gt;<br>&lt;!--&nbsp;正文基本格式&nbsp;--&gt;<br>&lt;!--&nbsp;标题格式&lt;FIRSTTITLE&gt;&lt;SECONDTITLE&gt;&lt;THIRDTITLE&gt;&lt;FOURTHTITLE&gt;&lt;FIFTHTITLE&gt;&nbsp;--&gt;<br><br>&lt;p&gt; &lt;SECONDTITLE&gt;标题&lt;/SECONDTITLE&gt; 原名James&nbsp;Ahern（詹姆斯·埃亨）。美国剧作家。他的作品是19世纪通俗情节剧和20世纪思想剧之间的桥梁。曾在巡回剧团当了几年演员，1879年发表与年轻的D.贝拉斯科合写的第一个剧本《果断的人们》，获得很大成功。剧本《离异》(1885)、《民兵》(1886)和《玛格丽特·弗莱明》(1890)却不受欢迎。人们认为&lt;HOTLINK&gt;《玛格丽特·弗莱明》&lt;HOTLINK&gt;（一部关于婚姻不忠的剧本）是他的主要成就。最受群众欢迎的剧本是《海边的地产》，1892年首次上演。他以刻画人物性格见长。&lt;/p&gt;<br>&lt;!--&nbsp;图片格式&nbsp;--&gt;<br>&lt;p&nbsp;align=&quot;center&quot;&gt;&lt;STORY&gt;&lt;PIC_TITLE&gt;赫恩&lt;/PIC_TITLE&gt;&lt;IMG&nbsp;src=&quot;image_jpg/images08/jieri01.jpg&quot;&gt;&lt;/IMG&gt;&lt;PIC_DESC/&gt;&lt;/STORY&gt;&lt;/p&gt;<br>&lt;!--&nbsp;图集格式--&gt;<br>&lt;STORY_GROUP&gt;<br>&lt;IMG_GROUP_TITLE&gt;图集标题&lt;/IMG_GROUP_TITLE&gt;<br>&lt;IMG_GROUP_DESC&gt;图集描述&lt;/IMG_GROUP_DESC&gt;<br>&lt;p&nbsp;align=&quot;center&quot;&gt;&lt;STORY&gt;&lt;PIC_TITLE&gt;图1&lt;/PIC_TITLE&gt;&lt;IMG&nbsp;src=&quot;image_jpg/images08/jieri01.jpg&quot;&gt;&lt;/IMG&gt;&lt;PIC_DESC/&gt;&lt;/STORY&gt;&lt;/p&gt;<br>&lt;p&nbsp;align=&quot;center&quot;&gt;&lt;STORY&gt;&lt;PIC_TITLE&gt;图2&lt;/PIC_TITLE&gt;&lt;IMG&nbsp;src=&quot;image_jpg/images08/jieri02.jpg&quot;&gt;&lt;/IMG&gt;&lt;PIC_DESC/&gt;&lt;/STORY&gt;&lt;/p&gt;<br>...<br>&lt;/STORY_GROUP&gt;<br>&lt;!--&nbsp;表格&nbsp;--&gt;<br>&lt;TABLE&gt;...&lt;/TABLE&gt;<br>&lt;/body&gt;<br>&lt;!--&nbsp;引文--&gt;<br>&lt;REFERENCE_LIST&gt;<br>&lt;REFERENCE_CONTENT&gt;....&lt;/REFERENCE_CONTENT&gt;<br>&lt;REFERENCE_CONTENT&gt;....&lt;/REFERENCE_CONTENT&gt;<br>&lt;/REFERENCE_LIST&gt;<br>&lt;/entry&gt;<br>&lt;entry&gt;...&lt;/entry&gt;<br>&lt;entry&gt;...&lt;/entry&gt;<br>...<br>&lt;/Root&gt;",
        },
        {
          name: "通用专题",
          text: "&lt;!--文件格式说明--&gt;<br>image_jpg(图片文件夹)<br>&nbsp;&nbsp;--jieri01.jpg<br>&nbsp;&nbsp;--jieri02.jpg<br>xml(xml文件夹)<br>&nbsp;&nbsp;--示例1.xml<br>&nbsp;&nbsp;--示例2.xml<br>&lt;Root&gt;<br>&lt;entry&gt;<br>&lt;Itemid&gt;6cb44af1-90ee-11e6-895f-d8cb8a4c2783&lt;/Itemid&gt;<br>&lt;PdfNum&gt;&lt;/PdfNum&gt;<br>&lt;PdfNum_end&gt;&lt;/PdfNum_end&gt;<br>&lt;itemcn&gt;阿尔及利亚－意大利输气管道&lt;/itemcn&gt;<br>&lt;itemen&gt;Algeria-Italy&nbsp;Natural&nbsp;Gas&nbsp;Pipeline&lt;/itemen&gt;<br>&lt;itempy&gt;A&#39;erjiliyɑ-Yidɑli&nbsp;Shuqi&nbsp;Guɑndɑo&lt;/itempy&gt;<br>&lt;body&gt;<br>&lt;!--&nbsp;正文基本格式&nbsp;--&gt;<br>&lt;!--&nbsp;标题格式&lt;FIRSTTITLE&gt;&lt;SECONDTITLE&gt;&lt;THIRDTITLE&gt;&lt;FOURTHTITLE&gt;&lt;FIFTHTITLE&gt;&nbsp;--&gt;<br><br>&lt;p&gt; &lt;SECONDTITLE&gt;标题&lt;/SECONDTITLE&gt; 原名James&nbsp;Ahern（詹姆斯·埃亨）。美国剧作家。他的作品是19世纪通俗情节剧和20世纪思想剧之间的桥梁。曾在巡回剧团当了几年演员，1879年发表与年轻的D.贝拉斯科合写的第一个剧本《果断的人们》，获得很大成功。剧本《离异》(1885)、《民兵》(1886)和《玛格丽特·弗莱明》(1890)却不受欢迎。人们认为&lt;HOTLINK&gt;《玛格丽特·弗莱明》&lt;HOTLINK&gt;（一部关于婚姻不忠的剧本）是他的主要成就。最受群众欢迎的剧本是《海边的地产》，1892年首次上演。他以刻画人物性格见长。&lt;/p&gt;<br>&lt;!--&nbsp;图片格式&nbsp;--&gt;<br>&lt;p&nbsp;align=&quot;center&quot;&gt;&lt;STORY&gt;&lt;PIC_TITLE&gt;赫恩&lt;/PIC_TITLE&gt;&lt;IMG&nbsp;src=&quot;image_jpg/images08/jieri01.jpg&quot;&gt;&lt;/IMG&gt;&lt;PIC_DESC/&gt;&lt;/STORY&gt;&lt;/p&gt;<br>&lt;!--&nbsp;图集格式--&gt;<br>&lt;IMG_GROUP&gt;<br>&lt;p&gt;&lt;STORY&gt;&lt;IMG&nbsp;src=&quot;image_jpg/TP0071_01.jpg&quot;&gt;&lt;/IMG&gt;&lt;PIC_TITLE&gt;阿富汗奥委会会徽&lt;/PIC_TITLE&gt;&lt;/STORY&gt;&lt;/p&gt;<br>&lt;p&gt;&lt;STORY&gt;&lt;IMG&nbsp;src=&quot;image_jpg/TP0071_02.jpg&quot;&gt;&lt;/IMG&gt;&lt;PIC_TITLE&gt;荷属安的列斯群岛奥委会会徽&lt;/PIC_TITLE&gt;&lt;/STORY&gt;&lt;/p&gt;<br>...<br>&lt;p&gt;&lt;GROUP_TITLE&gt;图集标题&lt;/GROUP_TITLE&gt;&lt;/p&gt;<br>&lt;p&gt;&lt;IMG_GROUP_DESC&gt;图集描述&lt;/IMG_GROUP_DESC&gt;&lt;/p&gt;<br>&lt;/IMG_GROUP&gt;<br>&lt;!--&nbsp;表格&nbsp;--&gt;<br>&lt;TABLE&gt;...&lt;/TABLE&gt;<br>&lt;/body&gt;<br>&lt;!--&nbsp;作者&nbsp;--&gt;<br>&lt;p&gt;&lt;AUTHOR&gt;林木西&lt;/AUTHOR&gt;&lt;/p&gt;<br>&lt;!--&nbsp;引文--&gt;<br>&lt;REFERENCE&gt;<br>&lt;REFERENCE_CONTENT&gt;....&lt;/REFERENCE_CONTENT&gt;<br>&lt;REFERENCE_CONTENT&gt;....&lt;/REFERENCE_CONTENT&gt;<br>&lt;/REFERENCE&gt;<br>&lt;/entry&gt;<br>&lt;entry&gt;...&lt;/entry&gt;<br>&lt;entry&gt;...&lt;/entry&gt;<br>...<br>&lt;/Root&gt;",
        },
      ],
      sortList: [
        {
          label: "不列颠",
          id: 10,
        },
        {
          label: "一版",
          id: 20,
        },
        {
          label: "二版",
          id: 30,
        },
        {
          label: "通用专题",
          id: 40,
        },
        {
          label: "通用多媒体",
          id: 50,
        },
      ],
      currentSortView: "",
      sourceTableData: [],
      currentPage: 1,
      pageSize: 10,
      totalSize: 50,
      dataText: "",
      optionData: [],
      multipleSelectionTable: [],
      editDialog: false,
      sortViewDialog: false,
      deleteDialog: false,
      createDialog: false,
      currentSortViewDialog: false,
      addSourceRules: {
        name: [
          { required: true, message: "请输入数据结构名称", trigger: "blur" },
        ],
        classify: [{ required: true, message: "请选择结构", trigger: "blur" }],
      },
      editSourceRules: {
        name: [
          { required: true, message: "请输入数据结构名称", trigger: "blur" },
        ],
      },
    };
  },
  components: {
    Menu,
    LeftSideBar,
  },
  mounted() {
    // 统一验证token
    var currentToken = cookies.get("token");
    $.ajaxSetup({
      headers: {
        AuthorizationToken: currentToken,
      },
      complete: function (xhr) {
        if (xhr.responseJSON.code == 401) {
          window.location.href = "/";
        }
      },
    });
    this.searchParam();
  },
  methods: {
    // 加载数据
    searchParam() {
      let that = this;
      // let params = Object.assign({}, this.sourceForm);
      // params.size = this.pageSize;
      // params.page = this.currentPage;
      $.ajax({
        type: "GET",
        dataType: "json",
        url: "/zyk/dictionary/getItemByCode",
        data: { code: "resourceConvert" },
        contentType: "application/json;charset=utf-8",
        success: function (response) {
          console.log(response);
          if (response.code == 200) {
            that.optionData = response.obj;
            if (response.obj && response.obj.length == 0) {
              that.dataText = "暂无数据";
            }
            // that.totalSize = response.obj.length;
            that.sourceTableData = response.obj;
            // that.currentPage = response.obj.pageNum;
          } else {
            that.$message({
              message: response.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
            });
          }
        },
        error: function (data) {
          console.log(data);
        },
      });
    },
    // 显示新增弹框
    firstCreate() {
      this.createDialog = true;
      this.addSourceForm = {
        name: "",
        remark: "",
        classify: "",
      };
    },
    // 新增字典项
    createSource(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.addSourceForm);
          //     if (this.addSourceForm.parentId) {
          //       delete this.addSourceForm.webUrl;
          //     }
          let that = this;
          //     that.noClick = true;
          $.ajax({
            url: "/zyk/c/dictionary/dictionaryItem/add",
            type: "POST",
            dataType: "json",
            data: this.addSourceForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "新增成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.createDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                  onClose: function () {
                    // that.noClick = false;
                  },
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑
    editSource(row) {
      // if (this.pageAuth.s || this.isadmin) {
      //   this.searchTreeData();
      // }
      this.editSourceForm = {
        id: row[0].id,
        name: row[0].name,
        remark: row[0].remark,
      };
      this.editDialog = true;
    },
    // 确认修改
    updateSource(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          // that.noClick = true;
          $.ajax({
            url: "/zyk/c/dictionary/dictionaryItem/update",
            type: "POST",
            dataType: "json",
            data: that.editSourceForm,
            error: function (xhr) {
              if (xhr.status == 401) {
                window.location.reload();
              }
            },
            success: function (data) {
              if (data.code == 200) {
                that.$message({
                  message: "修改成功",
                  duration: 2000,
                  showClose: true,
                  type: "success",
                  offset: 100,
                });
                that.searchParam();
                that.editDialog = false;
              } else {
                that.$message({
                  message: data.msg,
                  duration: 0,
                  showClose: true,
                  type: "error",
                  offset: 100,
                  onClose: function () {
                    // that.noClick = false;
                  },
                });
              }
            },
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 编辑、删除前确认
    preCheck(current) {
      if (this.multipleSelectionTable.length == 0) {
        this.$message({
          message: "请选中具体的组织机构",
          duration: 0,
          showClose: true,
          type: "error",
          offset: 100,
        });
      } else if (current == "toEdit") {
        // 编辑确认
        if (this.multipleSelectionTable.length == 1) {
          this.editSource(this.multipleSelectionTable);
        } else {
          this.$message({
            message: "请勿选择多个进行编辑",
            duration: 0,
            showClose: true,
            type: "error",
            offset: 100,
          });
        }
      } else if (current == "toDelete") {
        this.deleteDialog = true;
      }
    },
    // 删除
    onDelete() {
      let ids = this.multipleSelectionTable.map((item) => {
        return item.id;
      });
      console.log(ids);
      let that = this;
      // that.noClick = true;
      $.ajax({
        url: "/zyk/c/dictionary/dictionaryItem/remove",
        type: "POST",
        //contentType: 'application/json;charset=utf-8',
        dataType: "json",
        data: { ids: ids.toString() },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.reload();
          }
        },
        success: function (data) {
          console.log(data);
          if (data.code == 200) {
            that.$message({
              message: "删除成功",
              duration: 2000,
              showClose: true,
              type: "success",
              offset: 100,
            });
            that.searchParam();
            that.deleteDialog = false;
          } else {
            that.$message({
              message: data.msg,
              duration: 0,
              showClose: true,
              type: "error",
              offset: 100,
              onClose: function () {
                // that.noClick = false;
              },
            });
          }
        },
      });
    },
    // 选择表格某一行
    handleTableSelectionChange(val) {
      this.multipleSelectionTable = val;
    },
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.searchParam();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchParam();
    },
    sortPreview(row) {
      let that = this;
      console.log(row);
      var sortContent = this.sorttableData.filter(
        (item) => item.name == row.name
      );
      that.currentSortView = sortContent[0].text;

      this.currentSortViewDialog = true;
    },
  },
};
</script>

<style>
.el-table .cell {
  white-space: normal;
  word-break: break-all;
}
</style>